import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { errorMessage } from '../../constants/errorMessage'
import './qrScanCss.scss'
import CommonQr from '../../global/ScanQrCode/CommonQr'
import { isValidPromoCode } from '../../utils/helper'
import { useParams } from 'react-router-dom'

// PROMOCODE SCANNING QR
function ScanQr(props) {
    const { notify, setIsScanDisplay, setScanResult, scanResult, clasName, promocodePage, handleSubmitPromoCode, 
        setPromoCode, screen, handleValidateTicket } = props
    const [isDataRecorded, setIsDataRecorded] = useState(false)

    const {ticket_id} = useParams()
        
    useEffect(() => {
        const handlePopState = () => {
            window.history.pushState(null, document.title, window.location.href)
            setIsScanDisplay(false)
        }
        window.history.pushState(null, document.title, window.location.href)
        window.addEventListener('popstate', handlePopState)
        return () => {
            window.removeEventListener('popstate', handlePopState)
        }
    }, [])


    useEffect(() => {
        if (scanResult && scanResult != null) {
            //    Action for Scann

        }
    }, [scanResult])

    const handleScan = (data) => {
        const paymentDetails = (screen == 'extend' || screen == 'extendForm') ? JSON.parse(localStorage.getItem('ExtendData')) : JSON.parse(localStorage.getItem('paymentRecipt'))

        if (data?.text) {
            if (promocodePage && isValidPromoCode(data?.text, screen == 'transientForm')) {
                handleSubmitPromoCode(data?.text)
                setPromoCode(data?.text)
            }else if((paymentDetails && paymentDetails?.ticket_number) || ticket_id){
                let qrcodeId = data?.text?.split('/').pop()
                handleValidateTicket(qrcodeId, ticket_id ? ticket_id : (paymentDetails && paymentDetails?.ticket_number))
            }
            if (!isDataRecorded) {
                //Redirect
                // console.log(data?.text)
                // const facilityData = data?.text.split('https://demo-transient.parkengage.com/')
                // navigate(`/${facilityData[1]}`)
                setScanResult(data?.text)
                setIsScanDisplay(false)
                setIsDataRecorded(true)
            }
            setIsDataRecorded(true)
        } else {
            setIsDataRecorded(false)
        }
    }
    const doNothing = () => {
    }
    const handleError = (error) => {
        // notify('error', errorMessage?.somethingWentWrong)
        setIsDataRecorded(true)
        if(JSON.stringify(error + '').includes('Permission denied')) {
            notify('error', 'Please allow the Camera Permission to Scan the QR.')
        } else {
            notify('error', errorMessage?.somethingWentWrong)
        }
    }

    const sendBack = () => {
        setIsScanDisplay(false)
    }
    return (
        <div className={clasName ? clasName : 'zIndexHigh top-0 position-fixed bg-white h-100'}>
            <CommonQr
                isDisplayBack={true}
                handleClose={() => sendBack()}
                isParentCss={false}
                onError={handleError}
                onScan={!isDataRecorded ? handleScan : doNothing}
                notify={notify}
            />
        </div>
    )
}

ScanQr.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isFetching: PropTypes.bool,
    promocodePage: PropTypes.bool,
    scanResult: PropTypes.string,
    setScanResult: PropTypes.func,
    notify: PropTypes.func,
    setIsScanDisplay: PropTypes.func,
    handleSubmitPromoCode: PropTypes.func,
    setPromoCode: PropTypes.func,
    clasName: PropTypes.string,
    screen: PropTypes.string,
    handleValidateTicket: PropTypes.func,
}

ScanQr.defaulProps = {
    dispatch: noop,
    loader: false,
    isFetching: false,
    promocodePage: false,
    scanResult: '',
    setScanResult: noop,
    notify: noop,
    setIsScanDisplay: noop,
    handleSubmitPromoCode: noop,
    setPromoCode: noop,
    clasName: '',
    screen: '',
    handleValidateTicket: noop,
}

function mapStateToProps({ gatedCheckinReducer }) {
    return {
        loader: gatedCheckinReducer?.loader,
        isFetching: gatedCheckinReducer?.isFetching
    }
}
export default connect(mapStateToProps)(ScanQr)
